import { withAlpha } from './colorUtils';

export function getScrollbarStyles(theme, options = {}) {
  const { size = 10, thumbOpacity = 0.48, trackOpacity = 0.16, hoverOpacity = 0.68 } = options;

  const thumbColor = withAlpha(theme.vars.palette.secondary.main, thumbOpacity);
  const thumbHoverColor = withAlpha(theme.vars.palette.secondary.dark, hoverOpacity);
  const trackColor = withAlpha(theme.vars.palette.secondary.light, trackOpacity);

  return {
    scrollbarWidth: 'thin',
    scrollbarColor: `${thumbColor} ${trackColor}`,
    '&::-webkit-scrollbar': {
      width: size,
      height: size
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: thumbColor,
      borderRadius: 999,
      border: '2px solid transparent',
      backgroundClip: 'padding-box',
      minHeight: 28
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: thumbHoverColor
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: trackColor,
      borderRadius: 999
    },
    '&::-webkit-scrollbar-corner': {
      backgroundColor: 'transparent'
    }
  };
}
